import React, { useState } from 'react';

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import { useSoftUIController } from "context";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import { GoogleMap, LoadScript, Marker, DirectionsService, DirectionsRenderer } from '@react-google-maps/api';

const containerStyle = {
    width: '100%',
    height: '500px'
};

const DriverMap = (props) => {
    const [controller, dispatch] = useSoftUIController();
    const { driver } = props;
    const { deliveries, pickups } = controller;
    const [directions, setDirections] = useState(null)

    let activeDeliveries = deliveries.filter(d => d.driver === driver.email && !d.complete);
    let activePickups = pickups.filter(p => p.driver === driver.email && !p.complete);
    let waypoints = activeDeliveries.map(d => {
        return { location: `${d.address.address1} ${d.address.city}, ${d.address.state} ${d.address.zip}`, stopover: false};
    }).concat(activePickups.map(p => {
        return { location: `${p.address.address1} ${p.address.city}, ${p.address.state} ${p.address.zip}`, stopover: false};
    }))

    const directionsCallback = (res) => {
        if (res !== null) {
            if (res.status === 'OK') {
                if(directions ===  null) {
                    setDirections(res)
                }   
            } else {
                console.error('response: ', res)
            }
        } else {
            console.error('directions response was null');
        }
    }

    return (
        <Card>
            <SoftBox p={2}>
            <Grid container spacing={3}>
                <Grid item lg={12}>
                    <LoadScript googleMapsApiKey="AIzaSyA2hVfIzQNqmwRVi-dP4a73PSbh8eFJF_k">
                        <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={driver.coords}
                            zoom={16}>
                            { /* Child components, such as markers, info windows, etc. */ }
                            <>
                                <Marker position={driver.coords} />
                                <DirectionsService
                                    options={{ 
                                        destination: driver.coords,
                                        origin: driver.coords,
                                        travelMode: 'DRIVING',
                                        waypoints: waypoints,
                                        optimizeWaypoints: true
                                    }}
                                    // required
                                    callback={directionsCallback} />
                                <DirectionsRenderer options={{directions}} />    
                            </>
                        </GoogleMap>
                    </LoadScript>
                </Grid>
            </Grid>
            </SoftBox>
        </Card>
    );
};



export default React.memo(DriverMap);
